import { useCallback } from 'react';
import { useLinkingTracking } from '../orchestration/useLinkingTracking';
import {
	readLinkingFlowAttempt,
	resolveWaitingVariant,
} from './waitingVariants';

// Tracking de interacciones dentro de la waiting experience (quiz, memorama).
// Lee workflowId/method de storage al momento del click — sin workflowId no
// dispara nada (la pantalla dev /dev-test/linking-waiting monta estos
// componentes fuera del flujo real y no debe generar ruido).
export const useWaitingVariantTracking = () => {
	const { trackWaitingVariantInteracted } = useLinkingTracking();

	const trackInteraction = useCallback(
		(action: string, extra?: Record<string, unknown>) => {
			const { workflowId, method } = readLinkingFlowAttempt();
			if (!workflowId) return;
			const { variant } = resolveWaitingVariant(workflowId);
			trackWaitingVariantInteracted(method, workflowId, variant, action, extra);
		},
		[trackWaitingVariantInteracted],
	);

	return { trackInteraction };
};
